import { isRecommendationStripCompleted } from './existing-equipment';
import { existingSystemsHaveInventory } from './existing-systems-have-inventory';
import { CompositionPicks } from './system-composition-types';

export function shouldConfirmExistingEquipmentRemoval(
  existingSystems: ReadonlyArray<{
    uniqueId: string;
    components: readonly unknown[];
  }>,
  recommendationSelectionsBySystem: Record<
    string,
    { wantIds: number[] } | null | undefined
  >,
  wantCompositionPicksBySystem: Record<string, CompositionPicks> = {}
): boolean {
  return (
    existingSystemsHaveInventory(existingSystems) ||
    existingSystems.some((system) =>
      isRecommendationStripCompleted(
        recommendationSelectionsBySystem[system.uniqueId],
        wantCompositionPicksBySystem[system.uniqueId]
      )
    )
  );
}
